import Modal from 'components/Modal';
import PropTypes from 'prop-types';
import React from 'react';
import ResetPasswordForm from './ResetPasswordForm';
import { taxAgentText } from '../../../../../constants/bannerText';
import Tooltip from 'components/Tooltip/SimpleTooltip';
import { Link } from 'redux-little-router';
import { routeMap } from 'router';
import REACT_CONFIG from 'REACT_CONFIG';

class ResetPassword extends React.Component {
  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    onHideModal: PropTypes.func.isRequired,
    showInfoMessage: PropTypes.func.isRequired,
    handleClickToStartPage: PropTypes.func.isRequired,
  };
  state = { showTooltip: false };

  showInfoMessage = (text) => {
    const { showInfoMessage, onHideModal } = this.props;
    showInfoMessage(text);
    onHideModal();
  };

  render() {
    const { showModal, onHideModal, handleClickToStartPage } = this.props;
    return (
      <Modal type="large" onClose={onHideModal} showModal={showModal}>
        <div className={'boo'}>
          <h2>Восстановление пароля</h2>
          <p>
            Уважаемый пользователь! Если Вы ранее выбрали вариант восстановления пароля с помощью
            адреса электронной почты и в разделе «Профиль» указали телефон, подтвержденный адрес
            электронной почты и кодовое слово, пожалуйста, введите следующие реквизиты:
          </p>
          <ResetPasswordForm showInfoMessage={this.showInfoMessage} />
          <div>
            В противном случае для получения нового пароля Вам (или Вашему доверенному лицу – по
            нотариально заверенной доверенности) необходимо&nbsp;
            {!REACT_CONFIG.REACT_APP_HIDE_EXTERNAL_APPOINTMENT ? (
              <Link className={'link link__underline'} href={routeMap.externalAppointment}>
                обратиться
              </Link>
            ) : (
              'обратиться'
            )}{' '}
            в{' '}
            <span className="position-relative d-inline-block">
              <a
                onMouseLeave={() => this.setState({ showTooltip: false })}
                onMouseEnter={() => this.setState({ showTooltip: true })}
              >
                любой*
              </a>
              {this.state.showTooltip ? (
                <Tooltip
                  content={taxAgentText}
                  isFormClass={false}
                  position={'right'}
                  closeByClick={false}
                />
              ) : null}
            </span>{' '}
            налоговый орган России, независимо от места постановки на учет с документом,
            удостоверяющим личность. Данное требование связано с тем, что сервисом предоставляются
            сведения, составляющие налоговую тайну (статья 102 Налогового кодекса РФ). Также Вход в
            Личный кабинет можно осуществить с помощью учетной записи портала государственных услуг,
            подтвержденной в одной из уполномоченных организаций Единой системы идентификации и
            аутентификации (ЕСИА) (подробности читать на{' '}
            <a onClick={handleClickToStartPage}>стартовой странице</a> Личного кабинета
            налогоплательщика).
          </div>
        </div>
      </Modal>
    );
  }
}

export default ResetPassword;
